<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.customer') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="col-md-12 no-padding">
        <table
          id="dataTable"
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th>{{ $t('message.name') }}</th>
              <!-- <th style="max-width: 300px;">{{ $t('message.address') }}</th>
              <th style="max-width: 150px;">{{ $t('message.tel') }}</th>
              <th style="max-width: 150px;">{{ $t('message.email') }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in customers">
              <td>
                <router-link-custom
                  :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer_id, cus_name: item.customer_name}}"
                  :text="item.customer_name"
                  :to_appid="11"
                  :current_appid="11"/>
              </td>
              <!-- <td style="max-width: 300px;">
                {{ item.address }}
              </td>
              <td style="max-width: 150px;">
                {{ getPartnerContact(item.contacts).tel }}
              </td>
              <td style="max-width: 150px;">
                {{ getPartnerContact(item.contacts).email }}
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'Test',
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: false,
    }
  },
  computed: mapGetters({
    customers: 'getCustomers',
    getPartnerContact: 'getPartnerContact',
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // get customers
    await this.$store.dispatch('getCustomers')
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.contacts.title'),
      current: {
        app_name: 'contacts',
        app_id: 11,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearCustomers'])
  },
  methods: {

  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/contact/customer/All.vue